import styled from 'styled-components';

export const SearchInputContainer = styled.aside`
  position: absolute;
  display: flex;
  align-items: center;
  z-index: 1;
  right: 0;
`;
